// @flow
import type { Action } from '.'
import { Map } from 'immutable'
import { FILTER_COURSES } from 'actions/courses'

export type CoursesState = {
  filters: Map<string, Set<number> | string>,
}


export const initialValue: CoursesState = {
  filters: new Map(),
}


export default function coursesReducer (state: CoursesState, action: Action): CoursesState {
  const { payload } = action
  switch (action.type) {

    case FILTER_COURSES: {
      const filter = payload
      let filters = state.filters
      if (Array.isArray(filter))
        filter.forEach(item => {
          if (item.value === null)
            filters = filters.delete(item.property)
          else
            filters = filters.set(item.property, item.value)
        })
      else if (filter.value === null)
        filters = filters.delete(filter.property)
      else
        filters = filters.set(filter.property, filter.value)

      return { ...state, filters }
    }

    default:
      return state || initialValue

  }
}
